export default "__VITE_ASSET__pKBPDcB$__"